import { useState } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { Button, Text, Stack, Container, Paper, Group } from '@mantine/core';
import { Constants, border, colors, borderRadius } from '../constants';

const FreeTrialModalMobile = ({ isOpen, onClose, onChoosePlan, onContinueTrial }) => {
  const mobileModalStyle = Constants.components.modal.freeTrialModal;

  const handleChoosePlan = () => {
    onChoosePlan();
    onClose();
  };

  const handleContinueTrial = () => {
    onContinueTrial();
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel='Free Trial Information'
      style={mobileModalStyle}
    >
      <Paper
        shadow="xl"
        radius="15px"
        p="xl"
        style={{
          backgroundColor: colors.backgroundLight,
          border: `10px solid ${colors.primary}`,
        }}
      >
        <Stack spacing="lg" align="center">
          <Text
            size="xl"
            weight={700}
            align="center"
            style={{
              color: colors.white,
              fontSize: Constants.fontSize.xl,
              lineHeight: '1.2',
              marginBottom: '10px',
            }}
          >
            To enjoy full access to the app—including plant names, shopping lists, and more—please choose a plan on our website.
          </Text>

          <Stack spacing="md" w="100%" grow align="center">
            <Button
              onClick={handleChoosePlan}
              size="lg"
              variant="outline"
              style={{
                backgroundColor: "white",
                border: 'none',
                borderRadius: borderRadius.xl,
                height: 'auto',
                fontSize: Constants.fontSize.xxl,
                fontWeight: 'bold',
                //textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
                color: colors.primary,
                paddingTop: 20,
                paddingBottom: 20,
                paddingLeft: 5,
                paddingRight: 5,
                width: '60vw',
              }}
            >
              Choose a Plan
            </Button>

            <Button
              onClick={handleContinueTrial}
              size="lg"
              style={{
                backgroundColor: "transparent",
                border: 'none',
                borderRadius: borderRadius.xl,
                height: 'auto',
                fontSize: Constants.fontSize.xl,
                textDecoration: 'underline',
                color: colors.primary,
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 15,
                paddingRight: 15,
                //textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
              }}
            >
              Continue to Free Trial
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Modal>
  );
};

FreeTrialModalMobile.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onChoosePlan: PropTypes.func.isRequired,
  onContinueTrial: PropTypes.func.isRequired,
};

export default FreeTrialModalMobile;
